module.exports = __webpack_public_path__ + "img/close.532db114.svg";